import { s } from '@/theme/tokens';

export const resolveTableV2MetricValueGap = (_variant: 'detail' | 'table'): string => s('md');
